module.exports = __webpack_public_path__ + "b5f1580d4e369c03c383eebc57946db3.svg";